import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentStatusColorV2 } from '@ffd/api-client';
import { getStatusColorHex, getStatusTextColor, getStatusAbbreviation } from './helper';

@Component({
  selector: 'lib-appointment-status-chip',
  templateUrl: './appointment-status-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class AppointmentStatusChipComponent {
  @Input({ required: true }) public statusColor!: AppointmentStatusColorV2;

  protected getStatusColorHex(): string | null {
    return getStatusColorHex(this.statusColor);
  }

  protected getStatusTextColor(): string {
    return getStatusTextColor(this.statusColor);
  }

  protected getStatusAbbreviation(): string {
    return getStatusAbbreviation(this.statusColor);
  }
}
